import { render, staticRenderFns } from "./JModal.vue?vue&type=template&id=772dc090&"
import script from "./JModal.vue?vue&type=script&lang=js&"
export * from "./JModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports